module.exports = __webpack_public_path__ + "media/images/hero/glyph-a1-f69a984b6cfae017efe6786c68b38267.svg";